module.exports = __webpack_public_path__ + "static/img/14000598.d94c429e.png";